import React from 'react';
import ProfileForm from '../components/Auth/ProfileForm';
import { useAuth } from '../components/Auth/AuthContext';
import LoadingScreen from '../components/common/LoadingScreen';
import AuthRequired from '../components/Auth/AuthRequired';

const ProfilePage = () => {
  const { loading } = useAuth();

  if (loading) {
    return <LoadingScreen message="Loading profile..." />;
  }

  return (
    <AuthRequired>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <ProfileForm />
        </div>
      </div>
    </AuthRequired>
  );
};

export default ProfilePage;